import {assign} from "./voidash.js";
import {decodeQueryString, encodeQueryString} from "./utils";

export default class Router {
  constructor(view, opts) {
    this.view = view;
    this.opts = assign({history: []}, opts);

    window.addEventListener("hashchange", () => { this.handleHashChange(); });
    this.view.on("route", evt => { this.route(evt.params); });

    this.defaultParams = this.view.getDefaultRouteParams();
    this.params = assign({}, this.defaultParams, this.getURLParams());

    this.handleHashChange(true);
  }

  handleHashChange(force) {
    if(force || !location.hash || location.hash[1] === "?") {
      this.view.receiveRoute(assign(this.params, this.getURLParams()));
    }
  }

  route(params) {
    const nextParams = assign({}, this.params);

    Object.keys(params).forEach(key => {
      if (params[key] != null) nextParams[key] = params[key];
      else delete nextParams[key];
    });

    var qs = encodeQueryString(nextParams);

    var history = false;

    for(var i = 0; i < this.opts.history.length; i++) {
      const paramName = this.opts.history[i];
      if(params.hasOwnProperty(paramName) && params[paramName] !== this.params[paramName]) {
        history = true;
        break;
      }
    }

    if(history) {
      location.hash = qs;
    } else {
      location.replace("#" + qs)
    }
  }

  getURLParams() {
    var qs = location.hash && location.hash[1] === "?" && location.hash.substring(1);
    return qs ? decodeQueryString(qs) : this.defaultParams;
  }
}